module.exports = __webpack_public_path__ + "img/phone-cover-end.21fc73d0.png";